/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Workout_RecoveryInputs */

const en_coach_workout_recovery = /** @type {(inputs: Coach_Workout_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`25min Recovery`)
};

const de_coach_workout_recovery = /** @type {(inputs: Coach_Workout_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`25min Erholung`)
};

/**
* | output |
* | --- |
* | "25min Recovery" |
*
* @param {Coach_Workout_RecoveryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_workout_recovery = /** @type {((inputs?: Coach_Workout_RecoveryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Workout_RecoveryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_workout_recovery(inputs)
	return de_coach_workout_recovery(inputs)
});